import API from "./lib/api";
import { pointBasedHistoryUrl } from "./lib/url";


export const getAllPointBasedOfferHistoryApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}${pointBasedHistoryUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addPointBasedOfferHistoryApi = async (voucherHistoryData) => {
    try {
        
        const response = await API.post( 
            `restaurant/point-base-card-histories`,
            voucherHistoryData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const deletePointBasedOfferHistoryApi = async (id) => {
    try {
        
            const response = await API.delete(`restaurant/point-base-card-histories/${id}`);
            return response.data;
        } catch (error) {
            return (
                error.response?.data || {
                    status: "failure",
                    message: "Something went wrong.",
                }
            );
        }
}